export default "__VITE_ASSET__DoxTwRQw__"